import { css, useTheme } from "@emotion/react";
import { Field as DefaultField } from "formik";
import { useTranslation } from "react-i18next";

import {
  useThemeProps,
  handleComponentsProp,
  MaybeFragment,
} from "../../wsui/base";

import DefaultFormFieldDescription from "./FormFieldDescription.jsx";
import DefaultFormFieldError from "./FormFieldError.jsx";
import DefaultFormFieldLabel from "./FormFieldLabel.jsx";
import DefaultFormFieldWrapper from "./FormFieldWrapper.jsx";
import Select from "./Select.jsx";

export default function FormSelectField(props) {
  const theme = useTheme();
  const { t } = useTranslation();
  props = useThemeProps({ props, name: "FormSelectField" });
  props = useThemeProps({ props, name: "FormField" });
  let {
    inputProps = {},
    placeholder = t(["wsui.form.formSelectField.placeholder", "Select…"]),
    components,
    rowGap = [1, 2],
    options,
    type = "select",
    ...restProps
  } = props;
  let {
    Field,
    FormFieldDescription,
    FormFieldError,
    FormFieldLabel,
    FormFieldWrapper,
  } = handleComponentsProp(components, {
    Field: DefaultField,
    FormFieldDescription: DefaultFormFieldDescription,
    FormFieldError: DefaultFormFieldError,
    FormFieldLabel: DefaultFormFieldLabel,
    FormFieldWrapper: DefaultFormFieldWrapper,
  });

  let { ...restInputProps } = inputProps;

  return (
    <FormFieldWrapper
      // className={clsx(styles.component, className)}
      css={css`
        display: grid;
        grid-template-columns: 1fr;
        grid-row-gap: ${theme.getLength(rowGap)};
      `}
      type={type}
      {...restProps}
    >
      {({ name, controlProps, wrapperProps, type, id, multiple }) => (
        <MaybeFragment {...wrapperProps}>
          <FormFieldLabel
          // className={styles.label}
          />
          <FormFieldDescription
          // className={styles.description}
          />
          <div
          // className={styles.control}
          >
            <Field
              as={Select}
              type={type}
              options={options}
              // className={styles.input}
              name={name}
              id={id}
              placeholder={placeholder}
              multiple={multiple}
              {...controlProps}
              {...restInputProps}
            />
          </div>
          <FormFieldError
          // className={styles.error}
          />
        </MaybeFragment>
      )}
    </FormFieldWrapper>
  );
}
